import { OrganizationGeofencingCountryEntity } from '../entities/OrganizationGeofencingCountry';
import { authResource } from './Auth';
export const OrganizationGeofencingCountryResource = authResource({
    path: '/organizations/:organizationId/geofencing/countries/:geoCountryId?',
    schema: OrganizationGeofencingCountryEntity
});
